



















































































































import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import MainButton from '@/shared/buttons/main-button.component.vue';
import RuleScript from '@/domain/scripts/entity/rule-script.entity';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import RuleScriptService from '@/domain/scripts/service/rule-script.service';
import RuleHistoryService from '@/domain/scripts/service/rule-history.service';
import RuleUsage from '@/domain/scripts/entity/rule-usage.entity';
import RuleHistory from '@/domain/scripts/entity/rule-history.entity';
import RuleHistoryDetail from '@/domain/scripts/entity/rule-history-detail.entity';
import RuleScriptParameter from '@/domain/scripts/entity/rule-script-parameter.entity';
import { accessorForType, buildParameterSnippet } from '@/domain/scripts/rule-parameter-accessor';
import ScriptContent from './script-content.component.vue';
import ScriptEdition from './script-edition-component.vue';
import TabComponent from './rule-script-tab.component.vue';
import ParameterEdition from './parameters-edition-component.vue';
import RuleUsageModal from './rule-usage-modal.component.vue';
import RuleHistoryTab from './rule-history-tab.component.vue';
import DataDictionaryPanel from './data-dictionary-panel.component.vue';

@Component({
  components: {
    MainButton,
    ScriptContent,
    ScriptEdition,
    TabComponent,
    ParameterEdition,
    RuleUsageModal,
    RuleHistoryTab,
    DataDictionaryPanel,
  },
})

export default class NewScript extends Vue {
  @Prop() businessUnitId!: string;

  @Prop() ruleScript?: RuleScript;

  @Prop() editModeValue!: boolean;

  @Prop() previewModeValue!: boolean;

  valid: boolean = false;

  contentValid: boolean = false;

  parametersValid: boolean = false;

  ruleToEdit: RuleScript = RuleScript.of({});

  usageItems: RuleUsage[] = [];

  showUsageModal: boolean = false;

  editingFromVersion: string | null = null;

  draftVersion: string | null = null;

  created() {
    if (this.ruleScript) {
      this.ruleToEdit = this.ruleScript;
    }
    if (this.ruleToEdit.id) {
      this.loadUsage();

      // Parâmetros/Código Fonte usam v-tab-item (v-window-item), que só monta
      // o conteúdo quando a aba é visitada — se o usuário vai direto para
      // Histórico/Dicionário, contentValid/parametersValid nunca saem do
      // valor inicial (false) e o botão de salvar trava. A regra carregada
      // já passou pela validação do backend, então é seguro marcar como válida.
      this.contentValid = true;
      this.parametersValid = true;
    }
  }

  loadUsage() {
    RuleHistoryService.getUsage(this.businessUnitId, this.ruleToEdit.id)
      .then((usageItems: RuleUsage[]) => {
        this.usageItems = usageItems;
      }).catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  handleRuleUpdated(rule: RuleScript) {
    this.ruleToEdit = rule;
    this.editingFromVersion = null;
    this.draftVersion = null;
    this.loadUsage();
  }

  loadVersionIntoEditor(detail: RuleHistoryDetail) {
    this.ruleToEdit.name = detail.name;
    this.ruleToEdit.description = detail.description;
    this.ruleToEdit.script = detail.script;
    this.ruleToEdit.ruleType = detail.ruleType;
    this.ruleToEdit.parameters = detail.parameters;
    this.ruleToEdit.dataSourceId = detail.dataSourceId;
    this.editingFromVersion = detail.version;
    this.draftVersion = null;

    // Carga programática não passa pelo @input dos v-form filhos
    // (script-content/parameters-edition), então contentValid/parametersValid
    // não seriam reavaliados sozinhos. O snapshot carregado já passou pela
    // validação do backend quando foi salvo, então é seguro marcar como válido.
    this.contentValid = true;
    this.parametersValid = true;

    const tabComponent = this.$refs.tabComponent as any;
    if (tabComponent) {
      tabComponent.tab = 0;
    }
  }

  get versionIndicatorText(): string {
    if (this.draftVersion) {
      return `Rascunho salvo ${this.draftVersion} (não publicado)`;
    }
    if (this.editingFromVersion) {
      return `Editando ${this.editingFromVersion} (carregada do histórico, não publicada)`;
    }
    if (this.ruleToEdit.versionAtual) {
      return `Editando a partir da versão publicada ${this.ruleToEdit.versionAtual}`;
    }
    return 'Regra ainda não publicada';
  }

  insertParameterSnippet(parameter: RuleScriptParameter) {
    const expectedAccessor = accessorForType(parameter.type);
    const escapedName = parameter.name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const usageRegex = new RegExp(
      `context\\.getParameter\\(\\s*['"]${escapedName}['"]\\s*\\)(?:\\.(\\w+)\\(\\))?`,
    );
    const match = this.ruleToEdit.script.match(usageRegex);

    if (match) {
      const currentAccessor = match[1];
      if (currentAccessor === expectedAccessor) {
        VbSnackbarService.showSuccess(`'${parameter.name}' já está no script com o tipo correto`);
      } else {
        VbSnackbarService.showError(
          `'${parameter.name}' já está no script, mas com tipo diferente `
          + `(esperado .${expectedAccessor}()). Ajuste manualmente.`,
        );
      }
      return;
    }

    const snippet = buildParameterSnippet(parameter.name, parameter.type);
    this.ruleToEdit.script = `${snippet}\n${this.ruleToEdit.script}`;
    VbSnackbarService.showSuccess(`Variável '${parameter.name}' inserida no script`);
  }

  get titleText() {
    let title = 'Novo Cálculo';
    if (this.editModeValue) title = 'Editar Regra de cálculo';
    if (this.previewModeValue) title = 'Visualizar Regra de cálculo';
    return title;
  }

  get isValidAndEditable(): boolean {
    return this.contentValid
      && this.ruleToEdit.hasParameter()
      && this.ruleToEdit.hasScript()
      && this.parametersValid
      && !this.previewModeValue;
  }

  get saveButtonText(): string {
    return this.editModeValue ? 'Salvar como rascunho' : 'Salvar';
  }

  get saveButtonWidth(): string {
    return this.editModeValue ? '175px' : '115px';
  }

  handleSave() {
    if (this.editModeValue) {
      this.saveDraft();
    } else {
      this.saveNewRule();
    }
  }

  saveNewRule() {
    RuleScriptService.saveNewRuleScript(this.businessUnitId, this.ruleToEdit)
      .then((rule: RuleScript) => {
        this.ruleToEdit = rule;
        VbSnackbarService.showSuccess('Regra de cálculo salva com sucesso');
        this.$emit('created', rule);
        this.loadUsage();
      }).catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  saveDraft() {
    RuleHistoryService.saveDraft(this.businessUnitId, this.ruleToEdit.id, this.ruleToEdit)
      .then((history: RuleHistory) => {
        this.draftVersion = history.version;
        VbSnackbarService.showSuccess(
          'Rascunho salvo com sucesso. Publique na aba Histórico para aplicar as mudanças.',
        );
        this.reloadHistory();
      }).catch((err: any) => VbSnackbarService.handleHttpError(err));
  }

  reloadHistory() {
    const historyTab = this.$refs.historyTab as any;
    if (historyTab) {
      historyTab.loadHistory();
    }
  }

  back() {
    this.$emit('back')
  }
}

